import { render, staticRenderFns } from "./overviewPatient.vue?vue&type=template&id=b8637b1c&scoped=true&"
import script from "./overviewPatient.vue?vue&type=script&lang=js&"
export * from "./overviewPatient.vue?vue&type=script&lang=js&"
import style0 from "./overviewPatient.vue?vue&type=style&index=0&id=b8637b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8637b1c",
  null
  
)

export default component.exports